module.exports = __webpack_public_path__ + "img/map-zambia.5b58a684.png";